import { render } from "./MeetingsArchive.vue?vue&type=template&id=c48acccc&scoped=true"
import script from "./MeetingsArchive.vue?vue&type=script&lang=js"
export * from "./MeetingsArchive.vue?vue&type=script&lang=js"

import "./MeetingsArchive.vue?vue&type=style&index=0&id=c48acccc&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c48acccc"]])

export default __exports__